import { z } from 'zod';
import type { TripStatus } from './trip.schemas';

/**
 * Why a dispatched trip was stopped (gitaumoses4/chukua#56). A closed list rather than free text so a report can count them; the
 * dispatcher's own words go in `reason`.
 */
export const ABORT_REASON_CODES = ['driver_timeout', 'pre_trip_failed', 'customer_cancelled', 'container_not_released', 'route_change'] as const;
export type AbortReasonCode = (typeof ABORT_REASON_CODES)[number];

/** The statuses a trip can be aborted from; the API's `decideAbort` judges by this list and the web offers the action by it. */
export const ABORT_TRIP_STATUSES = ['dispatched', 'pre_trip_failed', 'in_transit', 'exception'] as const satisfies readonly TripStatus[];

/** `POST /trips/:id/abort`. */
export const abortTripInputSchema = z
  .object({
    reason: z.string().trim().min(1).max(500),
    reasonCode: z.enum(ABORT_REASON_CODES),
  })
  .strict();
export type AbortTripInput = z.infer<typeof abortTripInputSchema>;
